import React from 'react';
import { Container } from './Container';
import { DeliveryNotice } from './DeliveryNotice';
import { ProductMaintenanceNotice } from './ProductMaintenanceNotice';
import { TermsAndConditions } from './TermsAndConditions';

export const Notice = React.memo(() => {
  return (
    <Container>
      <DeliveryNotice />
      <ProductMaintenanceNotice />
      <TermsAndConditions />
    </Container>
  );
});
